import { jsx as _jsx } from "react/jsx-runtime";
import { Form } from 'antd';
const SpeakerForm = ({ form, onSubmit, initialValues, children, disabled = false, submitOnEnter, }) => {
    const handleKeyDown = (e) => {
        const target = e.target;
        if (e.key !== 'Enter') {
            return;
        }
        if (target.tagName === 'TEXTAREA') {
            return;
        }
        const antSelect = target.closest('.ant-select');
        if (antSelect !== null && antSelect.classList.contains('ant-select-open')) {
            return;
        }
        if (target.closest('#speaker-tree-select') !== null) {
            return;
        }
        if (target.closest('.ant-modal-body') !== null) {
            return;
        }
        e.stopPropagation();
        e.preventDefault();
        form.submit();
    };
    return (_jsx(Form, { form: form, labelCol: { style: { minWidth: 120 } }, labelWrap: true, labelAlign: "left", initialValues: initialValues, onFinish: onSubmit, onKeyDownCapture: submitOnEnter === true ? handleKeyDown : undefined, disabled: disabled, children: children }));
};
export default SpeakerForm;
